import {
  useI18next
} from "gatsby-plugin-react-i18next"
import styled from "styled-components"

import { LocaleData } from "types/gatsby-alias"
import { checkedLocaleLink } from "utils/routes"

import Button from "./buttons/Button"
import { ReactComponent as DownloadSVG } from "../images/global/download.svg"
import colors from "../styles/colors"
import media from "../styles/media"
import text from "../styles/text"

export default function CTA({ translations, languageOverride }: { translations: LocaleData, languageOverride?: string }) {
  const { language } = useI18next()
  const downloadFactSheet = () => {
    window.open(`/pdf/${languageOverride ?? language}/Galileo-Corporate-Fact-Sheet.pdf`, "_blank")
  }
  // Looks like in components the useTranslation hook is not working so that's why I'm using useI18next
  const link = checkedLocaleLink("/contact-us", language);

  return (
    <Wrapper>
      <CTAWrapper>
        <CTAHeader>{translations["Let's simplify fintech."]}</CTAHeader>
        <CTAButtons>
          <Button
            styledLink
            onClick={downloadFactSheet}
            secondary
          >
            {translations["Download the Fact Sheet"]}
            <Download />
          </Button>
          <Button styledLink href={link}>
            {translations["Contact Sales"]}
          </Button>
        </CTAButtons>
      </CTAWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${colors.blue800};
`

const CTAWrapper = styled.div`
  overflow-x: hidden;
  position: absolute;
  z-index: 4;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: auto;
  height: 6.867vw;
  border-bottom: 1px solid ${colors.blue700};
  left: 6.627vw;
  right: 6.627vw;
  bottom: 40vw;

  ${media.fullWidth} {
    gap: 175px;
    width: 1440px;
    height: 114px;
    bottom: 664px;
    margin: 0 auto;
  }

  ${media.tablet} {
    left: 9.277vw;
    right: 0;
    height: 9.473vw;
    gap: 0;
    width: 81.445vw;
    top: 0vw;
  }

  ${media.mobile} {
  position: initial;
    height: 53vw;
    gap: 5.333vw;
    flex-direction: column;
    overflow-x: unset;
    bottom: auto;
  }
`

const CTAHeader = styled.p`
  ${text.h4};
  color: white;
  width: 25.904vw;
  white-space: pre;

  ${media.fullWidth} {
    width: 600px;
    margin-left: 0;
  }
  ${media.tablet} {
    ${text.h5};
    width: 28.125vw;
    white-space: unset;
  }

  ${media.mobile} {
    ${text.h5};
    white-space: unset;
    width: 76.8vw;
    margin: 0 auto;
  }
`

const CTAButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.205vw;

  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {
    gap: 1.953vw;
  }

  ${media.mobile} {
    flex-direction: column;
    gap: 5.333vw;
  }
`

const Download = styled(DownloadSVG)`
  width: 1.506vw;
  height: 1.506vw;

  ${media.fullWidth} {
    width: 25px;
    height: 25px;
  }
`